module.exports = __webpack_public_path__ + "img/zeepson.7c19fa07.png";